<div id="modal-content-wrapper"
     [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
  <header id="modal-header">
    <!--    <h1 id="addEditDel-title">{{ modalData.title|translate }}</h1>-->
  </header>
  <section class="px-2" id="modal-body">
    <!------------------------------------------------delete------------------------------------------>
    <div *ngIf="modalData.name ==='delete'" style="min-height: 100px">
      <p>{{ modalData.description | translate}}</p>
    </div>

    <!------------------------------------------------edit------------------------------------------>
    <div class=" card card-user" >
      <div class=" card-body">
        <div class="row col-12 pb-5 pt-2"
             [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">

          <div class="row col-12 mx-auto">

            <div>
              <form [formGroup]="myForm" (ngSubmit)="submit()" style="display: inline-block">
                <div class="mb-2">
                  <label for="uploadedFile" class="k-cursor-pointer" style="font-size: 1.75rem;">+</label>
                  <input type='file' name="file" id="uploadedFile"
                         (change)="onSelectFile($event)"
                         style="color: #fff; margin: 0 18px;visibility: hidden">
                </div>
              </form>
            </div>

            <div class="row col-lg-12 mb-3 mx-auto">
              <div class="m-2" *ngFor="let file of filesList; let i = index">
                <div class="text-center p-1 file k-cursor-pointer" (click)="chooseFile(file.uniqueName, file.name)" (dblclick)="chooseFile(file.uniqueName, file.name);closeModal()" id="{{file.uniqueName}}">
                  <i class="fas fa-trash-alt k-cursor-pointer" style="position: absolute; right: 0; color: #f9c112"
                     (click)="deleteFile(file.uniqueName)"></i>
                  <img src="../../../../assets/img/pdf.png" style="width: 55px" alt="file.name"/>
                  <p class="py-1" style="font-size: 0.6rem">{{file.name}}</p>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

    </div>


  </section>
  <footer class="row d-flex justify-content-end mx-2">
    <input type="input" style="width: 0;height: 0; border: none;outline: none;background: transparent" autofocus/>
    <button class="btn mx-1" (click)="closeModal()">
      {{'Button.Close'|translate}}
    </button>
    <button class="btn mx-1" (click)="actionFunction()">
      {{ modalData.actionButtonText |translate}}
    </button>
  </footer>
</div>


